'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by li on 2016/4/11.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HomePageOrderBar = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HomePageOrderBar, _Component);

  function HomePageOrderBar() {
    (0, _classCallCheck3.default)(this, HomePageOrderBar);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(HomePageOrderBar).apply(this, arguments));
  }

  (0, _createClass3.default)(HomePageOrderBar, [{
    key: 'itemClick',
    value: function itemClick(filterStr) {
      var onItemClick = this.props.onItemClick;

      if (onItemClick) {
        var sTop = document.documentElement.scrollTop + document.body.scrollTop;
        onItemClick(filterStr);
        window.scrollTo(0, sTop);
      }
    }
  }, {
    key: 'search',
    value: function search() {
      var input = this.refs.searchInput;
      var onSearch = this.props.onSearch;

      if (onSearch) {
        var sTop = document.documentElement.scrollTop + document.body.scrollTop;
        onSearch(input.value);
        window.scrollTo(0, sTop);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./HomePageOrderBar.scss');
      var _props = this.props;
      var texts = _props.texts;
      var page = _props.page;
      var placeHolder = _props.placeHolder;
      var location = _props.location;

      return _react2.default.createElement(
        'div',
        { style: { marginTop: '6px', width: '100%', height: '53px', background: '#cccccc' } },
        texts instanceof Array ? texts.map(function (currentFilter, index) {
          var curClassName = styles.sel_co1;
          switch (index) {
            case 1:
              curClassName = styles.sel_co2;
              break;
            case 2:
              curClassName = styles.sel_co3 + ' ' + styles.w210;
              break;
            case 3:
              curClassName = styles.sel_co4 + ' ' + styles.w210;
              break;
            case 4:
              curClassName = styles.sel_co5;
              break;
            case 5:
              curClassName = styles.sel_co6;
              break;
            default:
              curClassName = styles.sel_co1;
          }
          return _react2.default.createElement(
            'a',
            { key: index, onClick: function onClick() {
                return _this2.itemClick(currentFilter.id);
              },
              className: styles.sel_sl + ' ' + (currentFilter.text ? styles.mouseHover : '') + ' ' + (location.query.hasOwnProperty(currentFilter.id) || location.query.orderItem === currentFilter.id || location.query.hasOwnProperty('honorId') && location.query.honorId === currentFilter.honorId || location.query.hasOwnProperty('isSoldOut') && location.query.isSoldOut === currentFilter.soldId || location.query.hasOwnProperty('shopType') && location.query.shopType === currentFilter.typeId || location.query.hasOwnProperty('workstationType') && location.query.workstationType === currentFilter.quyuType || location.query.hasOwnProperty('productCharactor') && location.query.productCharactor === currentFilter.customId ? styles.active : '') + ' ' + curClassName },
            currentFilter.text
          );
        }) : '',
        _react2.default.createElement(
          'div',
          { className: styles.sel_sl + ' ' + styles.sel_co6 + ' ' + styles.sel_wh,
            style: { display: page === 'experienceShopDetail' ? 'block' : 'none', float: 'right' } },
          _react2.default.createElement('input', { ref: 'searchInput', placeholder: placeHolder, className: styles.sel_ip }),
          _react2.default.createElement('img', { className: styles.soo, onClick: this.search.bind(this),
            src: 'http://tupian.goeasy.cn:9999/yipinwang/find.png', alt: '' })
        )
      );
    }
  }]);
  return HomePageOrderBar;
}(_react.Component), _class.propTypes = {
  texts: _react.PropTypes.array.isRequired,
  onSearch: _react.PropTypes.func,
  onItemClick: _react.PropTypes.func,
  page: _react.PropTypes.string,
  placeHolder: _react.PropTypes.string,
  location: _react.PropTypes.object
}, _temp);
exports.default = HomePageOrderBar;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/HomePageOrderBar/HomePageOrderBar.js
 ** module id = 1354
 ** module chunks = 0
 **/